import { connect } from 'react-redux';
import { userLogout } from '../../store/actions/login';
import HeaderComponent from './Header';

const mapStatetoProps = state => ({
  auth: state.auth,
});

const mapDispatchToProps = dispatch => ({
  dispatchUserLogout: () => dispatch(userLogout()),
});

export default connect(
  mapStatetoProps,
  mapDispatchToProps,
)(HeaderComponent);
